var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSixblocksLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.868,
    height: 35.948,
    viewBox: "0 0 78.868 35.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_footer_business_partner_web",
    "data-name": "Logo footer business partner web",
    transform: "translate(-112 -1037.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M88.769,33.346l-.112,1.742-.042.012a2.166,2.166,0,0,0-1.492-.853,3.33,3.33,0,0,0-.637-.065,2.186,2.186,0,0,0-.521.053,1.2,1.2,0,0,0-.37.154.642.642,0,0,0-.325.557.809.809,0,0,0,.284.675A2.537,2.537,0,0,0,86.731,36a6.037,6.037,0,0,1,1.321.3,2.568,2.568,0,0,1,.818.48,1.969,1.969,0,0,1,.6,1.54,2.321,2.321,0,0,1-.983,2.008,3.541,3.541,0,0,1-2.12.6,5.588,5.588,0,0,1-2.038-.391,2.851,2.851,0,0,1-.58-.3l.065-1.978.024-.018a2.567,2.567,0,0,0,2.41,1.267,1.783,1.783,0,0,0,1.576-.575.766.766,0,0,0,.13-.435.9.9,0,0,0-.077-.4.672.672,0,0,0-.255-.27,2.675,2.675,0,0,0-1.155-.3,4.68,4.68,0,0,1-1.327-.29,2.445,2.445,0,0,1-.823-.527,2.427,2.427,0,0,1,.183-3.293,2.958,2.958,0,0,1,2.029-.664A4.2,4.2,0,0,1,88.769,33.346Z",
    transform: "translate(55.728 1012.891)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M99.875,30.265A11.5,11.5,0,0,1,101.06,28.7l1.528,1.2q-.307.379-.568.74l-.545.776Zm1.913,7.469a5.539,5.539,0,0,0,.024.664h-1.5v-6.19h1.48Z",
    transform: "translate(46.239 1015.28)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M108.768,40.256l-2.1-3.033h1.853l1.1,1.889,1.185-1.889h1.724a1.747,1.747,0,0,0-.13.172l-1.931,2.754,2.192,3.264h-1.836L109.638,41.4l-1.173,2.008h-1.854Z",
    transform: "translate(42.275 1010.265)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M128.762,40.208a3.1,3.1,0,0,1-1.128.536,6.551,6.551,0,0,1-1.7.19,13.481,13.481,0,0,1-2.147-.184V32.944a12.859,12.859,0,0,1,1.993-.184,5.023,5.023,0,0,1,1.386.16,2.6,2.6,0,0,1,.885.432,1.656,1.656,0,0,1,.675,1.366,1.791,1.791,0,0,1-.61,1.389,1.976,1.976,0,0,1,1.119.853,2.256,2.256,0,0,1,.361,1.246,3.105,3.105,0,0,1-.2,1.17A2.04,2.04,0,0,1,128.762,40.208Zm-3.409-4.32a3.9,3.9,0,0,0,.622.041,1.646,1.646,0,0,0,.614-.1.869.869,0,0,0,.583-.922q0-.905-1.067-.906a6.78,6.78,0,0,0-.752.035Zm.876,1.267a5.212,5.212,0,0,0-.876.065v2.328a3.477,3.477,0,0,0,.871.107,2.666,2.666,0,0,0,.8-.109,1.784,1.784,0,0,0,.583-.3,1.229,1.229,0,0,0,.48-1Q128.089,37.155,126.229,37.155Z",
    transform: "translate(32.168 1012.891)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M141.875,38.978a5.54,5.54,0,0,0,.024.664h-1.506V30.816h1.481Z",
    transform: "translate(22.392 1014.036)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M146.945,40.181a3.547,3.547,0,0,1,.222-1.247,3.038,3.038,0,0,1,2.989-2,2.977,2.977,0,0,1,2.286.906,3.147,3.147,0,0,1,.811,2.245,3.239,3.239,0,0,1-.835,2.286,3.376,3.376,0,0,1-4.7.018A3.167,3.167,0,0,1,146.945,40.181Zm1.439-.036a2.14,2.14,0,0,0,.125.723,1.7,1.7,0,0,0,.355.6,1.666,1.666,0,0,0,1.292.539,1.42,1.42,0,0,0,1.167-.527,2.04,2.04,0,0,0,.414-1.327,2.016,2.016,0,0,0-.426-1.339,1.544,1.544,0,0,0-1.25-.545,1.516,1.516,0,0,0-1.262.58A2.047,2.047,0,0,0,148.384,40.145Z",
    transform: "translate(18.537 1010.434)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M169.584,42.668a2.842,2.842,0,0,1-2.079.663,3.111,3.111,0,0,1-2.245-.835,2.976,2.976,0,0,1-.882-2.251,3.151,3.151,0,0,1,3.341-3.311,3.309,3.309,0,0,1,1.836.48l-.237,1.516-.042-.006a1.371,1.371,0,0,0-.6-.45,3.075,3.075,0,0,0-1.019-.178,2,2,0,0,0-.8.13,1.459,1.459,0,0,0-.5.361,1.838,1.838,0,0,0-.415,1.256A1.659,1.659,0,0,0,167.608,42a2.82,2.82,0,0,0,.646-.065,2.317,2.317,0,0,0,.5-.178,1.426,1.426,0,0,0,.651-.551l.042.017Z",
    transform: "translate(8.278 1010.434)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M181.705,39.369a5.59,5.59,0,0,0,.041.782h-1.492v-8.47h1.451V36.87l2.707-2.908h1.759l-2.334,2.458,1.332,1.818q.433.688.652,1.007l.391.551c.118.154.217.273.3.356h-.935a3.929,3.929,0,0,0-.895.088l-1.848-2.7-1.125,1.2Z",
    transform: "translate(-1.066 1013.526)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M198.677,43.331a4.3,4.3,0,0,1-2.517-.61q.012-.177.035-.4l.054-.427.058-.524a.633.633,0,0,1,.019-.113c0-.005.035.026.094.1a1.425,1.425,0,0,0,.338.251,3.057,3.057,0,0,0,.574.261,4.472,4.472,0,0,0,1.469.243q1.025,0,1.025-.681a.348.348,0,0,0-.2-.325,3.35,3.35,0,0,0-1.028-.27,4.611,4.611,0,0,1-1.111-.27,2.376,2.376,0,0,1-.7-.426,1.6,1.6,0,0,1-.5-1.226,1.709,1.709,0,0,1,.71-1.452,3.689,3.689,0,0,1,4.051.178c-.027.1-.057.2-.088.3-.091.26-.158.448-.2.562l-.136.349c-.008.031-.014.047-.018.047a.509.509,0,0,1-.095-.124,1.906,1.906,0,0,0-1.162-.569,2.582,2.582,0,0,0-.5-.047q-1.078,0-1.078.651a.373.373,0,0,0,.225.344,3.564,3.564,0,0,0,1.152.331,4.06,4.06,0,0,1,1.111.288,1.921,1.921,0,0,1,.61.435,1.734,1.734,0,0,1,.427,1.226,1.641,1.641,0,0,1-.669,1.357A3.078,3.078,0,0,1,198.677,43.331Z",
    transform: "translate(-10.427 1010.434)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M85.492,72.348a4.3,4.3,0,0,1-2.517-.61c.008-.119.02-.253.035-.4l.054-.427c.032-.281.051-.455.059-.524a.6.6,0,0,1,.019-.113c0-.006.035.026.094.1a1.44,1.44,0,0,0,.339.252,3.105,3.105,0,0,0,.574.26,4.485,4.485,0,0,0,1.469.243q1.025,0,1.025-.681a.349.349,0,0,0-.2-.326,3.358,3.358,0,0,0-1.028-.269,4.587,4.587,0,0,1-1.111-.27,2.388,2.388,0,0,1-.7-.426,1.6,1.6,0,0,1-.5-1.227,1.708,1.708,0,0,1,.711-1.45,3.214,3.214,0,0,1,1.949-.522,3.254,3.254,0,0,1,2.1.7q-.041.154-.088.3-.136.391-.2.563l-.136.349c-.008.032-.014.047-.018.047a.512.512,0,0,1-.095-.124,1.905,1.905,0,0,0-1.161-.568,2.585,2.585,0,0,0-.5-.048q-1.078,0-1.078.652a.37.37,0,0,0,.225.343,3.57,3.57,0,0,0,1.151.332,4.047,4.047,0,0,1,1.111.287,1.926,1.926,0,0,1,.61.436,1.736,1.736,0,0,1,.427,1.226,1.639,1.639,0,0,1-.669,1.356A3.075,3.075,0,0,1,85.492,72.348Z",
    transform: "translate(56.185 993.358)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M97.7,69.2a3.542,3.542,0,0,1,.222-1.247,3.035,3.035,0,0,1,2.988-2,2.979,2.979,0,0,1,2.287.906,3.149,3.149,0,0,1,.811,2.245,3.247,3.247,0,0,1-.835,2.287,3.376,3.376,0,0,1-4.7.018A3.169,3.169,0,0,1,97.7,69.2Zm1.439-.035a2.149,2.149,0,0,0,.125.723,1.712,1.712,0,0,0,.355.6,1.665,1.665,0,0,0,1.292.539,1.421,1.421,0,0,0,1.167-.527,2.321,2.321,0,0,0-.012-2.665,1.542,1.542,0,0,0-1.25-.545,1.515,1.515,0,0,0-1.262.581A2.047,2.047,0,0,0,99.14,69.162Z",
    transform: "translate(47.518 993.358)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M117.247,68a5.585,5.585,0,0,0,.023.663h-1.5V59.834h1.481Z",
    transform: "translate(36.887 996.958)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M126.982,71.857a2.542,2.542,0,0,1-1.652.627,1.862,1.862,0,0,1-1.5-.646,2.617,2.617,0,0,1-.521-1.723V67.763a9.06,9.06,0,0,0-.051-1.359,1.859,1.859,0,0,0-.074-.222c.181.016.371.023.568.023h.492q.2,0,.515-.018v3.43q0,1.22.664,1.415a1.558,1.558,0,0,0,.438.059,1.394,1.394,0,0,0,1.125-.509V66.205h1.469v5.432a4.321,4.321,0,0,0,.047.758h-1.516Z",
    transform: "translate(32.523 993.222)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M142.611,68.712a1.208,1.208,0,0,0,1.048-.4h.047l.018,1.374a1.852,1.852,0,0,1-1.078.385,4.032,4.032,0,0,1-.53.03,2.249,2.249,0,0,1-.686-.119,1.5,1.5,0,0,1-.631-.385,2.381,2.381,0,0,1-.539-1.723V65.187h-.895c0-.115-.006-.231-.006-.349v-.912a.323.323,0,0,1,.006-.1h.895V62.137h1.451v1.688h1.628v1.362h-1.628V67.6q0,.93.515,1.06A1.417,1.417,0,0,0,142.611,68.712Z",
    transform: "translate(23.002 995.602)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M151.566,59.282a11.478,11.478,0,0,1,1.185-1.564l1.528,1.2q-.307.379-.568.741l-.545.775Zm1.913,7.469a5.549,5.549,0,0,0,.024.663H152V61.224h1.48Z",
    transform: "translate(15.817 998.203)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M159.182,69.2a3.533,3.533,0,0,1,.222-1.247,3.035,3.035,0,0,1,2.988-2,2.979,2.979,0,0,1,2.287.906,3.149,3.149,0,0,1,.812,2.245,3.246,3.246,0,0,1-.835,2.287,3.377,3.377,0,0,1-4.7.018A3.17,3.17,0,0,1,159.182,69.2Zm1.439-.035a2.148,2.148,0,0,0,.124.723,1.719,1.719,0,0,0,.355.6,1.665,1.665,0,0,0,1.291.539,1.42,1.42,0,0,0,1.167-.527,2.321,2.321,0,0,0-.012-2.665,1.542,1.542,0,0,0-1.25-.545,1.516,1.516,0,0,0-1.262.581A2.049,2.049,0,0,0,160.621,69.162Z",
    transform: "translate(11.335 993.358)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M179.232,71.5a4.32,4.32,0,0,0,.047.758h-1.487V66.07h1.439V66.6a2.582,2.582,0,0,1,1.67-.646,1.966,1.966,0,0,1,1.552.658,2.534,2.534,0,0,1,.581,1.741v3.323a2.845,2.845,0,0,0,.047.586H181.6v-3.21q0-1.736-1.054-1.736a1.538,1.538,0,0,0-1.309.806Z",
    transform: "translate(0.382 993.358)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M18.13,25.839h5.831V20.007h5.833V14.175H18.13Z",
    transform: "translate(94.348 1023.829)",
    fill: "#28b6ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M35.625,76.7v5.832H18.13V70.868h5.832V76.7Z",
    transform: "translate(94.348 990.464)",
    fill: "#86bc44",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M29.794,48.353V60.017H23.962V54.185H18.13V42.521h5.832v5.832Z",
    transform: "translate(94.348 1007.146)",
    fill: "#5b3061",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M46.476,68.358V56.694h5.832v5.833h5.831V74.19H52.308V68.358Z",
    transform: "translate(77.666 998.805)",
    fill: "#b44784",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M58.14,45.844v-17.5H52.308V34.18H46.477v5.832h5.831v5.832Z",
    transform: "translate(77.665 1015.488)",
    fill: "#ca1d2a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M32.3,31.671h5.831V25.839h5.833V20.007H49.8V14.175H38.134v5.832H32.3Z",
    transform: "translate(86.007 1023.829)",
    fill: "#f98526",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M24.167,77.862h0V72.03H19.292V82.738H35.831V77.862H24.167Z",
    transform: "translate(93.664 989.78)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M52.514,63.689V57.856H47.639V68.564H53.47V74.4h4.875V63.689H52.514Z",
    transform: "translate(76.981 998.122)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M25.124,60.222H30V49.516H24.167V43.684H19.292V54.391h5.832Z",
    transform: "translate(93.664 1006.463)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M24.167,20.212H30V15.337H19.292V26.044h4.875Z",
    transform: "translate(93.664 1023.145)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M53.471,35.343H47.639v4.875H53.47V46.05h4.875V29.511H53.471Z",
    transform: "translate(76.981 1014.804)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M39.3,21.169H33.465V31.876H38.34V26.045h5.832V20.213H50V15.337H39.3Z",
    transform: "translate(85.323 1023.145)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M28.631,13.013H16.968V48.961H41.251V37.3h0V19.8h0V13.013H28.631Zm-10.707.956H28.631v4.875H22.8v5.832H17.924Zm0,22.371V25.633H22.8v5.831h5.832V42.172H23.756V36.341H17.924ZM34.463,48H17.924V37.3H22.8v5.831H34.463ZM40.295,37.3V48H35.42V42.172H29.588V31.465h4.875V37.3h5.832Zm0-.957H35.42V30.508H29.588V25.634h5.832V19.8H40.3Zm0-22.371v4.876H34.463v5.831H28.631v5.831H23.756V19.8h5.833V13.969Z",
    transform: "translate(95.032 1024.513)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixblocksLogoDark);
export default __webpack_public_path__ + "static/media/sixblocks-logo-dark.8f881074ed8db9bfc6974b5a4588ae28.svg";
export { ForwardRef as ReactComponent };